import { useEffect, useContext, useState } from "react";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import ChartsHandler from "../../../../components/Charts/ChartsHandler.tsx";
import "./DashboardCotacao.css";
import { Card } from "primereact/card";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useLocation } from "react-router-dom";
import { getCotacaoDash } from "../../../../services/ModuloGerenciador/Cotacao.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import { motion } from "framer-motion";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2.js";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import IconButton from "../../../../core/components/IconButton.tsx";
import {
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../../core/utils/UtilityDates.ts";

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Cidade Origem",
		field: "cidadeOrigem",
	},
	{
		nomeColuna: "Estado Origem",
		field: "estadoOrigem",
	},
	{
		nomeColuna: "Cidade Destino",
		field: "cidadeDestino",
	},
	{
		nomeColuna: "Estado Destino",
		field: "estadoDestino",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
];

function DashboardCotacao() {
	const { profile, contextoEmbarque, hasRegra } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [openToastErro, setOpenToastErro] = useState(false);

	const [porcentagemCotacoesAguardando, setPorcentagemCotacoesAguardando] =
		useState();
	const [porcentagemCotacoesCarregadas, sePorcentagemCotacoesCarregadas] =
		useState();
	const [
		porcentagemCotacoesNaoCarregadas,
		setPorcentagemCotacoesNaoCarregadas,
	] = useState();

	const [textoErro, setTextoErro] = useState("");

	const [dadosCotacao, setDadosCotacao] = useState([]);

	const [dadosCotacao2, setDadosCotacao2] = useState([]);

	const [numeroEmbarque, setNumeroEmbarques] = useState(0);

	const [loading, setLoading] = useState(true);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const imprimir = () => {
		window.print();
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Dashboard"));
		}
	}, [profile?.token]);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const limpar = () => {
		buscarSearchReset();
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.embarqueInicio}=${valuesPesquisa.embarqueFinal}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getCotacaoDash(
			profile?.token,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				setNumeroEmbarques(result.data.numeroEmbarques);
				setDadosCotacao(result.data.pagina.grafico1.pizza);
				setDadosCotacao2(result.data.pagina.grafico2.pizza);
				setPorcentagemCotacoesAguardando(
					result.data.porcentagemCotacoesAguardando.toFixed(2)
				);
				sePorcentagemCotacoesCarregadas(
					result.data.porcentagemCotacoesCarregadas.toFixed(2)
				);
				setPorcentagemCotacoesNaoCarregadas(
					result.data.porcentagemCotacoesNaoCarregadas.toFixed(2)
				);
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarSearchReset = async () => {
		setLoading(true);
		await getCotacaoDash(
			profile?.token,
			primeiroDiaDosMesFormatado,
			ultimoDiaDosMesFormatado
		)
			.then((result) => {
				setNumeroEmbarques(result.data.numeroEmbarques);
				setDadosCotacao(result.data.pagina.grafico1.pizza);
				setDadosCotacao2(result.data.pagina.grafico2.pizza);
				setPorcentagemCotacoesAguardando(
					result.data.porcentagemCotacoesAguardando.toFixed(2)
				);
				sePorcentagemCotacoesCarregadas(
					result.data.porcentagemCotacoesCarregadas.toFixed(2)
				);
				setPorcentagemCotacoesNaoCarregadas(
					result.data.porcentagemCotacoesNaoCarregadas.toFixed(2)
				);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response?.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	useEffect(() => {
		if (valuesPesquisa.contexto && profile?.token) {
			buscarSearch();
		}
	}, [valuesPesquisa.contexto, profile?.token]);

	const location = useLocation();

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname, contextoEmbarque]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="Cotações" />

			<div className="dashboards">
				<div className="containerBuscas1">
					<Separator direction="horizontal" size="2xl" />
					<div className="filtro-embarque">
						<FiltroV2
							classe="div-filtrar-faturamento-v2"
							classOption="select-options"
							itensFiltro={itensFiltro}
							valuesPesquisa={valuesPesquisa}
							setValuesPesquisa={setValuesPesquisa}
							buscarSearch={buscarSearch}
							limpar={limpar}
						/>
					</div>
					<IconButton
						theme="dark"
						onClick={imprimir}
						icon="Printer"
						backgroundColor="#FFFFFF"
						hoverColor="#CCC"
						size="2xl"
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
						gap: 120,
					}}
				>
					<div className="card-ontime-azul">
						<div className="card-header-ontime">Aguardando</div>
						<div className="card-body">{porcentagemCotacoesAguardando}%</div>
					</div>
					<div className="card-ontime-azul">
						<div className="card-header-ontime">Carregadas</div>
						<div className="card-body">{porcentagemCotacoesCarregadas}%</div>
					</div>
					<div className="card-ontime-azul">
						<div className="card-header-ontime">Não Carregadas</div>
						<div className="card-body">{porcentagemCotacoesNaoCarregadas}%</div>
					</div>
				</div>
				<div className="charts">
					{!loading ? (
						<div>
							<div className="graficosCotacao">
								<div className="item-dash-user">
									<Card>
										<ChartsHandler
											data={dadosCotacao}
											type={"pie"}
											height={480}
											width={570}
											title={"Usuário Responsável"}
										/>
									</Card>
								</div>
								<div className="item-dash-user">
									<Card>
										<ChartsHandler
											data={dadosCotacao2}
											type={"pie"}
											height={480}
											width={570}
											title={"Usuário Responsável"}
										/>
									</Card>
								</div>
							</div>
							<br></br>
							<br></br>
						</div>
					) : (
						<LoadingComponent />
					)}
				</div>
			</div>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</motion.div>
	);
}

export default DashboardCotacao;
